module.exports = __webpack_public_path__ + "static/media/calendar.19df10a7.svg";